<div [formGroup]="estimateTableFormGroup" class="estimate-table-container">

    <table class="estimate-table">
        <tr class="estimate-table-header-row">
            <th class="table-definition-estimate-totals width-218">{{ 'ESTIMATE_COSTS' | translate}}</th>
            <th class="table-definition width-110">{{ 'COST' | translate}}</th>
            <th class="table-definition width-70">{{ 'ESCALATE' | translate}}</th>
            <th class="table-definition width-70">{{ 'PERCENT_TDC' | translate}}</th>
            <th class="table-definition width-70">
                <ng-container *ngIf=" getMarkUpToggleValue ; else noMUColumn">
                    {{ 'MARK_UP_PERCENT' | translate }}
                </ng-container>
                <ng-template #noMUColumn>
                    {{ 'MARGIN_PERCENT' | translate }}
                </ng-template>
            </th>
            <th class="table-definition-toggle-button width-210">
                <label class="switch" [class.disabled]="isMarkUpToggleDisabled">
                    <input type="checkbox" formControlName="markUpToggle" (change)="setIsMarkUpSelected()" />
                    <span class="slider round">
                        <p class="toggle-button-label">
                            <ng-container *ngIf=" getMarkUpToggleValue ; else noMU$">
                                {{ 'MU' | translate }}$
                            </ng-container>
                            <ng-template #noMU$>{{ 'GM' | translate }}$</ng-template>
                        </p>
                    </span>
                </label>
            </th>
            <th class="table-definition width-110">{{ 'SELL_PRICE' | translate }}</th>
        </tr>
    </table>
    <hr class="no-margin" />
    
    <div class="custom-expansion-panel">
    
        <app-sol-estimate-table-material-costs 
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [materialCostsFormGroup]="materialCostsFormGroup"
            [isCollaborativeNotEdit]="isCollaborativeNotEdit"
        ></app-sol-estimate-table-material-costs>
    
        <app-sol-estimate-table-labor-costs
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [laborCostsFormGroup]="laborCostsFormGroup"
        ></app-sol-estimate-table-labor-costs>
    
        <app-sol-estimate-table-subcontractors-costs
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [subContractorsCostsFormGroup]="subContractorCostsFormGroup"
        ></app-sol-estimate-table-subcontractors-costs>
    
        <app-sol-estimate-table-misc-risk-travel-costs
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [miscRiskTravelCostsFormGroup]="miscRiskTravelCostsFormGroup"
            [riskDialogRequiredData]="riskDialogRequiredData"
            [isCollaborativeNotEdit]="isCollaborativeNotEdit"
        ></app-sol-estimate-table-misc-risk-travel-costs>
    
        <app-sol-estimate-table-tax-not-included
            *ngIf="taxVisibility.showTaxNotIncluded"
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [taxNotIncludedFormGroup]="taxNotIncludedFormGroup"
        ></app-sol-estimate-table-tax-not-included>

        <app-sol-estimate-table-tax-material-rate
            *ngIf="taxVisibility.showTaxMaterialRate"
            [taxMaterialRateFormGroup]="taxMaterialRateFormGroup"
            [isCollaborativeNotEdit]="isCollaborativeNotEdit"
        ></app-sol-estimate-table-tax-material-rate>
    
        <app-sol-estimate-table-technology-fee
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsPricingMode]="sellAsPricingModeValue"
            [technologyFeeFormGroup]="technologyFeeFormGroup"
            [isCollaborativeNotEdit]="isCollaborativeNotEdit"
        ></app-sol-estimate-table-technology-fee>
    
        <app-sol-estimate-table-sub-totals
            [subTotalsFormGroup]="subTotalsFormGroup"
        ></app-sol-estimate-table-sub-totals>

        <app-sol-estimate-table-tax-material-labor-rate
            *ngIf="taxVisibility.showTaxMaterialLaborRate"
            [taxMaterialLaborRateFormGroup]="taxMaterialLaborRateFormGroup"
        ></app-sol-estimate-table-tax-material-labor-rate>
    
        <hr/>
    
        <app-sol-estimate-table-sell-as
            [isMarkUpSelected]="getMarkUpToggleValue"
            [sellAsFormgroup]="sellAsFormGroup"
            [isCollaborativeNotEdit]="isCollaborativeNotEdit"
        ></app-sol-estimate-table-sell-as>
    </div>
</div>


